
import { defineComponent, ref, watch } from "vue";
import { disableBodyOverflow, enableBodyOverflow } from "../mixins";

const __default__ = defineComponent({
  name: "Modal",

  props: {
    isOpen: {
      required: true,
      type: Boolean
    },
    width: {
      type: String,
      default: "1280px"
    },
    height: {
      type: String,
      default: "777px"
    },
    showCloseButton: {
      type: Boolean,
      default: true
    }
  },

  setup(props, { emit }) {
    const pressed = ref(false);
    const moved = ref(false);

    const close = () => {
      if (!moved.value) {
        emit("toggle");
      }
    };

    const pressing = () => {
      pressed.value = true;
      moved.value = false;
    };

    const moving = () => {
      moved.value = true;
    };

    watch(
      () => props.isOpen,
      newVal => {
        if (newVal) {
          disableBodyOverflow();
        } else {
          enableBodyOverflow();
        }
      },
      { immediate: true }
    );

    return {
      pressed,
      pressing,
      moving,
      close
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "d60864fa": (_ctx.width),
  "1ea22dec": (_ctx.height)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__